/* *******************************************************************
#
# Copyright 2023 Adobe
# All Rights Reserved.
#
# NOTICE: All information contained herein is, and remains
# the property of Adobe and its suppliers, if any. The intellectual
# and technical concepts contained herein are proprietary to Adobe
# and its suppliers and are protected by all applicable intellectual
# property laws, including trade secret and copyright laws.
# Dissemination of this information or reproduction of this material
# is strictly forbidden unless prior written permission is obtained
# from Adobe.
*********************************************************************/

import { gql } from '@apollo/client';

export const THEME_FRAGMENT = gql`
  fragment themeAllFields on Theme {
    createdAt
    updatedAt
    id
    title
    status
    description
    weight
    imageUrl
    collections(sort: sameAsIds, sortDir: asc) {
      total
      hasMore
      items {
        id
        title
        description
        imageUrl
        assets {
          items {
            id
          }
          total
          hasMore
        }
      }
    }
  }
`;

export const GET_THEME = gql`
  query Theme($id: String!) {
    theme(id: $id) {
      ...themeAllFields
    }
  }

  ${THEME_FRAGMENT}
`;

export const GET_THEMES = gql`
  query Themes(
    $limit: Int
    $page: Int
    $filters: ThemeFilters
    $search: String
  ) {
    themes(limit: $limit, page: $page, filters: $filters, search: $search) {
      items {
        ...themeAllFields
      }
      total
      hasMore
    }
  }

  ${THEME_FRAGMENT}
`;

export const DELETE_THEME = gql`
  mutation DeleteTheme($id: String!) {
    deleteTheme(id: $id)
  }
`;

export const CREATE_UPDATE_THEME = gql`
  mutation CreateOrUpdateTheme($id: String, $theme: ThemeInput!) {
    createOrUpdateTheme(id: $id, theme: $theme) {
      ...themeAllFields
    }
  }

  ${THEME_FRAGMENT}
`;
